<template>
  <comBox>
    <template v-slot:name><h4>{{$store.state.module1.isChina?'平均值':'average value'}}</h4></template>
    <template v-slot:other>{{crTime.substring(0,16)}}</template>
    <template v-slot:content>
      <div>
         <p style="textAlign:left;paddingTop:0.1rem;paddingRight:0.1rem;height:0.2rem;"> <span v-for="dev in devId" :key="dev.code"><span class="qiuqiu" :style="{background: dev.color}"></span>{{dev.dev.substring(dev.dev.length-4)}}</span></p>
        <div class="bug"><div class="yu">{{todo.value!==null?todo.value:'--'}}</div><water v-if="todo" :type="todo.name" :num="todo.value" style="position:absolute;left:68%;top:15%;zIndex:199;"></water></div>
        <div class="bugBottom">
          <span>{{todo?todo.nickname:'--'}}</span>
          <span>{{todo?todo.unit:'--'}}</span>
        </div>
      </div>
        <div class="pm-num">
          <div class="swiper-wrapper" :class="{flexContent:items.length==7,flexContent2:items.length>7}">
            <div class="pm-num-content" v-for="(item, index) in items" :key="index" @click="trans(item)">
              <div class="ty swiper-slide" v-if="item.value!==null" style="cursor:pointer;">
                <span>{{item.nickname}} <span>{{item.unit}}</span></span>
                <div class="tr">{{item.nickname==='CO2'?parseInt(item.value):item.value}}</div>
              </div>
              <div class="ty swiper-slide" v-else style="cursor:pointer;">
                <span>{{item.nickname}} <span>{{item.unit}}</span></span>
                <div class="tr">--</div>
              </div>
            </div>
          </div>
        </div>
    </template>
  </comBox>
</template>

<script>
import comBox from '../comBox/comBox.vue'
import water from '../water/water.vue'
export default {
  props: ['items', 'crTime', 'devId'],
  components: {
    comBox,
    water
  },
  data () {
    return {
      todo: '',
      swiper: null
    }
  },
  watch: {
    items (value) {
      this.$nextTick(() => {
        this.todo = value[0]
      })
    }
  },
  created () {
    var u = JSON.parse(window.localStorage.getItem('unit'))
    if (u) {
      var item = [
        {
          name: 'PM2.5',
          unit: u.pm25
        },
        {
          name: 'TVOC',
          unit: u.tvoc
        },
        {
          name: 'HCHO',
          unit: u.hcho
        }
      ]
      this.$store.commit('setU', item)
    }
  },
  methods: {
    trans (item) {
      if (item.nickname !== 'TEMP' && item.nickname !== 'RH' && item.nickname !== 'Nai') {
        this.todo = item
      }
      if (item.nickname === 'noise') {
        item.value = parseFloat((parseFloat(item.value) / 10).toFixed(1))
      }
    }
  }
}
</script>

<style scoped lang='less'>
.bug{
  margin:0.2rem 0;
  .yu{
    font-size:0.8rem;
    font-weight:blod;
    position:relative;
  }
}
.bugBottom{
  span{
    margin:0.1rem 0.1rem;
  }
  span:first-child{
    font-weight:bold;
    opacity:0.8;
  }
  span:last-child{
    opacity:0.8;
  }
}
.pm-num{
    margin-top:0.2rem;
    position:relative;
    width:100%;
    overflow-y: scroll;
    height:2.2rem;
    .pm-num-content{
      width:31%;
      .ty{
        width:90%;
        margin:0 auto;
        background:rgba(0,0,0,0.03);
        height:0.9rem;
        border-radius:0.1rem;
        display:flex;
        text-align:center;
        flex-direction:column;
        align-items:center;
        margin-top:0.1rem;
        justify-content:space-around;
      }
        .tr{
          position:relative;
          font-weight:900;
          font-size:0.24rem;
          span{
            font-size:0.1rem;
            opacity:0.6;
            transform:scale(0.8);
            position:absolute;
            bottom:-0.05rem;
            left:100%;
          }
        }
        span{
          font-size:0.12rem;
          margin-top:-0.05rem;
          font-weight:600;
          span{
          font-size:0.12rem;
          font-weight:400;
          opacity:0.6;
          transform:scale(0.6);
        }
        }
    }
    .ty:hover{
      box-shadow: 0px 0px 2px 4px rgba(0,0,0,0.04);
    }
}
.qiuqiu{
  display:inline-block;
  width:0.1rem;
  height:0.1rem;
  border-radius:50%;
  margin:0 0.1rem;
  background:red;
}
.swiper-wrapper{
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  justify-content: space-between;
}
.flexContent {
  .pm-num-content:nth-child(4) {
    width: 25%;
  }
  .pm-num-content:nth-child(5) {
    width: 25%;
  }
  .pm-num-content:nth-child(6) {
    width: 25%;
  }
  .pm-num-content:nth-child(7) {
    width: 25%;
  }
}
.flexContent2 {
  .pm-num-content {
    width:25% !important
  }
}
</style>
